import CONFIG from "@APP/config";
import { RequestPagination, ResponsePagination, RTP, RTPQueryFilter } from "@APP/types";

import request from "../request";

export const getPaymentRequests = (pagination?: RequestPagination, filter?: RTPQueryFilter) => {
  const { page, entries } = { page: 0, entries: 50, ...pagination };

  return request<{ data: RTP[]; links: ResponsePagination }>({
    method: "GET",
    url: `${CONFIG.API.ROOT_URL}/${CONFIG.API.VERSION}/request-to-pay/payment-requests`,
    params: {
      page: `${page * entries};;;${entries}`,
      ...filter,
    },
  });
};

export const getPaymentRequest = async (requestId: string) => {
  const response = await request<{ data: RTP[] }>({
    method: "GET",
    url: `${CONFIG.API.ROOT_URL}/${CONFIG.API.VERSION}/request-to-pay/payment-requests`,
    params: { requestId },
  });

  return response.data.data[0];
};

export const getPayments = async (orgId: string) => {
  const response = await request({
    method: "GET",
    url: `${CONFIG.API.ROOT_URL}/${CONFIG.API.VERSION}/admin/request-to-pay/payment-requests`,
    params: {
      orgId,
    },
  });

  return response;
};

export const resendPaymentRequest = async (requestId: string) => {
  const response = await request<string>({
    method: "POST",
    url: `${CONFIG.API.ROOT_URL}/${CONFIG.API.VERSION}/request-to-pay/send/${requestId}`,
  });

  return response.data;
};

export const updateRTPStatusToPaid = (requestId: string) => {
  return request({
    method: "PUT",
    url: `${CONFIG.API.ROOT_URL}/${CONFIG.API.VERSION}/request-to-pay/${requestId}/paid`,
  });
};

export const getPaymentsFromUserName = async (from: string, username: string) => {
  const response = await request({
    method: "GET",
    url: `${CONFIG.API.ROOT_URL}/${CONFIG.API.VERSION}/admin/request-to-pay/payment-requests`,
    params: {
      from,
      username,
    },
  });

  return response.data.data;
};

export const getPaymentsFromUserOrg = async (from: string, orgId: string[]) => {
  const baseUrl = `${CONFIG.API.ROOT_URL}/${CONFIG.API.VERSION}/admin/request-to-pay/payment-requests`;

  const orgIdParams = orgId.map((id) => `orgId=${encodeURIComponent(id)}`).join("&");
  const url = `${baseUrl}?from=${encodeURIComponent(from)}&${orgIdParams}`;

  const response = await request({
    method: "GET",
    url: url,
  });

  return response.data.data;
};

export const getAdminPaymentRequest = async (requestId: string) => {
  const response = await request<{ data: RTP[] }>({
    method: "GET",
    url: `${CONFIG.API.ROOT_URL}/${CONFIG.API.VERSION}/admin/request-to-pay/payment-requests`,
    params: { requestId },
  });

  return response.data.data[0];
};
